module.exports = __webpack_public_path__ + "static/media/sf_2100.a528f5e1dad7072e4526edbefc3941dd.png";